import { render, staticRenderFns } from "./CampaignReporting.vue?vue&type=template&id=56bbd7d2&"
import script from "./CampaignReporting.vue?vue&type=script&lang=js&"
export * from "./CampaignReporting.vue?vue&type=script&lang=js&"
import style0 from "./CampaignReporting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports